import { Button, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Alert from "@material-ui/lab/Alert";
import React, { useState } from "react";
import MaskedNumber from "../../../../public-dashboard/features/signup/masked_number";
import DialogWrapper from "./DialogWrapper";

const useStyles = makeStyles((theme) => ({
  root: { marginBottom: theme.spacing(2) },
  formControl: {
    marginBottom: theme.spacing(2),
  },
  form: {
    padding: theme.spacing(2),
  },
  item: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
}));

export default function AddMobileNumber(props) {
  const classes = useStyles();

  const { error, handleSubmit, handleClose } = props;
  const [phone, setPhone] = useState("+1868");

  const handleChange = (prop, value) => {
    setPhone(value);
  };

  const onSubmit = (event) => {
    event.preventDefault();
    handleSubmit(phone);
  };

  function onClose() {
    setPhone("");
    handleClose();
  }

  return (
    <DialogWrapper {...props} handleClose={onClose}>
      <form className={classes.form} onSubmit={onSubmit}>
        <Grid container direction="row" justifyContent="center" spacing={2}>
          <Grid item xs={12}>
            <MaskedNumber
              handleChange={handleChange}
              value={phone}
              isRegDisable={false}
            />
          </Grid>
          {error && (
            <Grid item xs={12}>
              <Alert severity="error"> {error} </Alert>
            </Grid>
          )}
          <Grid item xs={6}>
            <Button fullWidth onClick={onClose} variant="outlined">
              Cancel
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button variant="contained" color="primary" type="submit" fullWidth>
              Confirm
            </Button>
          </Grid>
        </Grid>
      </form>
    </DialogWrapper>
  );
}
